
function Error() {
    return(
        <>
        <div>
            Error, page not found.
        </div>
        </>
    )
}
export default Error;